module.exports = __webpack_public_path__ + "assets/img/allGone.deda0c85.png";